export default __webpack_public_path__ + "static/media/sil-logo.e971a5b5.svg";